export class AssociatedTestSerializer {
  static deserialize = data => (
    data && {
      name: data.name,
      path: data.path,
    }
  );
}
